<template>
	<div class="imgText">
		<div class="warp">
			<div class="account">
				1949年4月，太原解放，山西的博物馆事业也荡涤尘埃，焕然一新，山西省博物馆藏品征集渐成规模。1954-1965年，是山西省博物馆接受捐赠的黄金十年。李宗仁、傅作义、冀朝鼎、罗静宜、董寿平等先生所捐古代书画作品，精品叠出，尤其是傅山翰墨大量入藏，逐渐形成了特色馆藏，是傅山研究的重要宝藏。
			</div>
			<div class="tab-content">
				<div>
					<dl v-for="(item,index) in allData" :key="index">
						<router-link tag="a" :to="{path:'pic',query:{id:item.id}}">
							<dt>
								<img :src="item.img" alt="">
							</dt>
						</router-link>
						<dd>
							<h3>{{item.title}}</h3>
							<p>{{item.etitle}}</p>
						</dd>
					</dl>
				</div>
			</div>
		</div>
		<div class="goback" @click="goback"></div>
	</div>
</template>
<script type="text/javascript">
    export default {
        data(){
            return{
                allData:[{
                    id:'unit2_01',
                    img:require('../static/imgs/proList2/proList2_01.jpg'),
                    title:' 行书七言联',
                    etitle:'张之万（清）',
                    size:'纵132厘米，横31.2厘米',
                    donor:'马鑫先生捐赠'
                },{
                    id:'unit2_02',
                    img:require('../static/imgs/proList2/proList2_02.jpg'),
                    title:' 《紫藤蜜蜂图》轴',
                    etitle:'齐白石（现代）',
                    size:'纵97厘米，横39.5厘米',
                    donor:'尹正斋先生捐赠'
                },{
                    id:'unit2_03',
                    img:require('../static/imgs/proList2/proList2_03.jpg'),
                    title:'行书七言诗轴',
                    etitle:'朱雯（清）',
                    size:'纵207厘米，横49.3厘米',
                    donor:'马鑫先生捐赠'
                },{
                    id:'unit2_04',
                    img:require('../static/imgs/proList2/proList2_04.jpg'),
                    title:'《接蝠图》轴',
                    etitle:'黄慎（清）',
                    size:'纵192厘米，横109厘米',
                    donor:'1953年尹正斋先生捐赠'
                },{
                    id:'unit2_05',
                    img:require('../static/imgs/proList2/proList2_05.jpg'),
                    title:'《云峰霖雨图》轴',
                    etitle:'高凤翰（清）',
                    size:'纵125厘米，横46厘米',
                    donor:'1954年吴元善先生捐赠'
                },{
                    id:'unit2_06',
                    img:require('../static/imgs/proList2/proList2_06.jpg'),
                    title:'《子夜歌图》轴',
                    etitle:'改琦（清）',
                    size:'纵118厘米，横39.5厘米',
                    donor:'1954年吴元善先生捐赠'
                },{
                    id:'unit2_07',
                    img:require('../static/imgs/proList2/proList2_07.jpg'),
                    title:'仿元人山水册',
                    etitle:'赫奕（清）',
                    size:'纵47.5厘米，横33厘米',
                    donor:'1956年张会斗先生捐赠'
                },{
                    id:'unit2_08',
                    img:require('../static/imgs/proList2/proList2_08.jpg'),
                    title:'《兰竹图》册',
                    etitle:'钱载（清）',
                    size:'纵23厘米，横26.6厘米',
                    donor:'1956年张会斗先生捐赠'
                },{
                    id:'unit2_09',
                    img:require('../static/imgs/proList2/proList2_09.jpg'),
                    title:'《丛林流水图》轴',
                    etitle:'程淓（清）',
                    size:'纵133厘米，横71厘米',
                    donor:'1956年张会斗先生捐赠'
                },{
                    id:'unit2_10',
                    img:require('../static/imgs/proList2/proList2_10.jpg'),
                    title:'《雪景山水》横幅',
                    etitle:'戴克昌（清）',
                    size:'纵116厘米，横237厘米',
                    donor:'1958年贾玉祥先生捐赠'
                },{
                    id:'unit2_11',
                    img:require('../static/imgs/proList2/proList2_11.jpg'),
                    title:'《麻姑献寿图》轴',
                    etitle:'焦秉贞（清）',
                    size:'纵148.5厘米，横76.3厘米',
                    donor:'1960年刘画南先生捐赠'
                },{
                    id:'unit2_12',
                    img:require('../static/imgs/proList2/proList2_12.jpg'),
                    title:'《僧王像》轴',
                    etitle:'无款（清）',
                    size:'纵170厘米，横83厘米',
                    donor:'1960年刘画南先生捐赠'
                },{
                    id:'unit2_13',
                    img:require('../static/imgs/proList2/proList2_13.jpg'),
                    title:'《岁寒三友图》轴',
                    etitle:'王岱（清）',
                    size:'纵112厘米，横38厘米',
                    donor:'1960年梁寯先生捐赠'
                },{
                    id:'unit2_14',
                    img:require('../static/imgs/proList2/proList2_14.jpg'),
                    title:'《太华冲雪图》卷',
                    etitle:'秦炳文（清）',
                    size:'纵33厘米，横69厘米',
                    donor:'1961年董寿平先生捐赠'
                },{
                    id:'unit2_15',
                    img:require('../static/imgs/proList2/proList2_15.jpg'),
                    title:'《汉书下酒图》卷',
                    etitle:'董文涣（清）',
                    size:'纵28.7厘米，横57.5厘米',
                    donor:'1961年董寿平先生捐赠'
                },{
                    id:'unit2_16',
                    img:require('../static/imgs/proList2/proList2_16.jpg'),
                    title:'《老屋校书图》卷',
                    etitle:'温忠翰（清）',
                    size:'纵32厘米，横129厘米',
                    donor:'1961年董寿平先生捐赠'
                },{
                    id:'unit2_17',
                    img:require('../static/imgs/proList2/proList2_17.jpg'),
                    title:'《松石图》轴',
                    etitle:'汪洛年（民国）',
                    size:'纵76.2厘米，横29.5厘米',
                    donor:'1961年常风玄先生捐赠'
                },{
                    id:'unit2_18',
                    img:require('../static/imgs/proList2/proList2_18.jpg'),
                    title:'临王羲之《明府帖》轴',
                    etitle:'傅山（清）',
                    size:'纵76.5厘米，横38.2厘米',
                    donor:'1963年傅作义先生捐赠'
                },{
                    id:'unit2_19',
                    img:require('../static/imgs/proList2/proList2_19.jpg'),
                    title:'行书五绝诗轴',
                    etitle:'陈继儒（明）',
                    size:'纵78.5厘米，横18厘米',
                    donor:'1964年罗静宜女士捐赠'
                },{
                    id:'unit2_20',
                    img:require('../static/imgs/proList2/proList2_20.jpg'),
                    title:'草书《游房山山寺》诗轴',
                    etitle:'王铎（清）',
                    size:'纵236厘米，横53厘米',
                    donor:'1964年罗静宜女士捐赠'
                },{
                    id:'unit2_21',
                    img:require('../static/imgs/proList2/proList2_21.jpg'),
                    title:'草书杜甫《夔州歌》之四诗轴',
                    etitle:'傅山（清）',
                    size:'纵185厘米，横56厘米',
                    donor:'1964年罗静宜女士捐赠'
                },{
                    id:'unit2_22',
                    img:require('../static/imgs/proList2/proList2_22.jpg'),
                    title:' 行书王昌龄《芙蓉楼送辛渐》诗轴',
                    etitle:'孙嘉淦（清）',
                    size:'纵175厘米，横77.5 厘米',
                    donor:'马鑫先生捐赠'
                },{
                    id:'unit2_23',
                    img:require('../static/imgs/proList2/proList2_23.jpg'),
                    title:'篆书《孟子·滕文公下》句轴',
                    etitle:'王澍（清）',
                    size:'纵109厘米，横58厘米',
                    donor:'1964年罗静宜女士捐赠'
                },{
                    id:'unit2_24',
                    img:require('../static/imgs/proList2/proList2_24.jpg'),
                    title:'行书录《内史与谢尚书书》轴',
                    etitle:'包世臣（清）',
                    size:'纵128厘米，横55.5厘米',
                    donor:'1964年罗静宜女士捐赠'
                },{
                    id:'unit2_25',
                    img:require('../static/imgs/proList2/proList2_25.jpg'),
                    title:'《山水图》轴',
                    etitle:'严载（清）',
                    size:'纵96厘米，横39.5厘米',
                    donor:'1964年罗静宜女士捐赠'
                },{
                    id:'unit2_26',
                    img:require('../static/imgs/proList2/proList2_26.jpg'),
                    title:'行书五言诗轴',
                    etitle:'吴雯（清）',
                    size:'纵79厘米，横28厘米',
                    donor:'1975年王世庆先生捐献'
                },{
                    id:'unit2_27',
                    img:require('../static/imgs/proList2/proList2_27.jpg'),
                    title:'行书诗册',
                    etitle:'祁寯藻（清）',
                    size:'纵26厘米，横21.5厘米',
                    donor:'1975年王世庆先生捐献'
                },{
                    id:'unit2_28',
                    img:require('../static/imgs/proList2/proList2_28.jpg'),
                    title:'扇画合轴',
                    etitle:'宋葆淳等（清）',
                    size:'纵52厘米，横158厘米',
                    donor:'郝秉寯先生捐赠'
                },{
                    id:'unit2_29',
                    img:require('../static/imgs/proList2/proList2_29.jpg'),
                    title:'《芙蓉水鸟图》轴',
                    etitle:'张敔（清）',
                    size:'纵179.5厘米，横45厘米',
                    donor:'朱绍钦先生捐赠'
                },{
                    id:'unit2_30',
                    img:require('../static/imgs/proList2/proList2_30.jpg'),
                    title:'《杨二酉父母之诰命》卷',
                    etitle:'杨二酉（清）',
                    size:'纵30厘米，横181厘米',
                    donor:'游介忱先生捐赠'
                }]
            }
        },
        mounted(){
            this.curdata=this.allData;
        },
        methods:{
            goback(){
                if(window.history.length == 1){
                    this.$router.push({path:"/"})
                }else{
                    this.$router.go(-1)
                }
            }
        }
    }
</script>
<style scoped>
	.imgText{
		min-height:100%;
		background-color: #f1f1f1;
	}
	.goback{
		width: 1.63rem;
		height: 1.63rem;
		background:url(../static/imgs/goback.png);
		background-size: 100% 100%;
		position: fixed;
		right: .17rem;
		top:50%;
		margin-top: -.815rem;
	}
	.warp{
		margin: 0 auto;
		padding-top: .2rem;
	}
	.account{
		background: url('../static/imgs/account.png') no-repeat center / cover;
		width:6.3rem;
		height:3.22rem;
		margin:0 .24rem .4rem;
		padding:.3rem .36rem;
		font-size: .28rem;
		line-height: .46rem;
		letter-spacing: .03rem;
		color:#555;
	}
	.title{
		width: 100%;
		text-align: left;
		font-size:20px;
		position: relative;
		margin-bottom: .8rem;
	}
	.title span{
		text-indent:0.14rem;
		letter-spacing: 3px;
		display: inline-block;
		z-index: 3;
		position: absolute;
	}
	.title em{
		display: inline-block;
		width: 0.85rem;
		height:9px;
		background: #e6bb70;
		left: 0.20rem;
		position: absolute;
		z-index: 1;
		top:10px;
	}
	.cont{
		width: 90%;
		margin: 0 auto;
	}
	.cont p{
		font-size: 16px;
		color:#666666;
		line-height: 30px;
		text-align: justify;
		margin-bottom: .10rem;
	}
	.cont dl{
		width: 100%;
		margin-bottom:.10rem;
	}
	.cont dl dt img{
		width: 100%;
	}
	.cont dl dd{
		font-size:14px;
		color:#adadad;
		margin-top: 0.15rem;
		line-height: 20px;
	}
	.butn{
		/*background:url(../static/bj1.png);*/
		height:.4rem;
		background-size: 100%;
		margin-top:.25rem;
		position: relative;
	}
	.btnC{
		width: 0.45rem;
		height: 0.23rem;
		border-radius: 50px;
		background:#fff;
		box-shadow: 0px 1px 15px #ededed;
		text-align: center;
		line-height: 0.23rem;
		margin: 0 auto;
		margin-top: -0.11rem;
		position: absolute;
		left: 50%;
		margin-left: -0.25rem;
		color:#e6bb70;
	}
	.activeClass{
		height: 2rem;
		overflow:hidden;
	}
	.hideClass{
		height: auto;
	}
	.tab-tilte{
		width:1500px;
	}
	.tab-tilte li{
		float: left;
		width:1rem;
		padding: 10px 0;
		text-align: center;
		cursor: pointer;
		color:#cdcdcd;
		font-size: 18px;
		font-weight: bolder;
	}
	/* 点击对应的标题添加对应的背景颜色 */
	.tab-tilte .active{
		color: #e6bb70;
	}
	.tab-content div{
		padding-right: .4rem;
		margin-top:.2rem;
		column-count:2;
		padding-left: .03rem;
	}
	.tab-content div dl{
		margin-left: .2rem;
		width:3.4rem;
		background: #fff;
		display: inline-block;
		margin-bottom: .2rem;
		border-radius: .1rem;
	}
	.tab-content div dl dt{
		justify-content: center;
		align-items: center;
	}
	.tab-content div dl dt img{
		max-width:100%;
		max-height: 100%;
		border-radius: 4px 4px 0 0;
	}
	.tab-content div dl dd{
		padding-bottom: .46rem;
		background:#fff;
	}
	.tab-content h3{padding:.29rem .21rem .2rem;font-size: .28rem;line-height: normal;font-weight: bold;color:#333;}
	.tab-content p{padding:0 .21rem;color:#666;font-size: .24rem;}

</style>